export const LINE_COLOR = '#76b900'
export const LINE_COLOR_2 = '#00afb9'
export const REFERENCE_LINE_COLOR = '#c1c1c1'
export const REFERENCE_LINE_WIDTH = 2
export const CHART_HEIGHT = 350
